<template>
  <layout-fullscreen bg="/images/photo-2.jpg">
    <remax-logo />
    <h3 class="heading t-normal t-inverse t-center">
      Discover the best properties in Malta & Gozo and find your perfect match.
    </h3>
    <div class="button-group">
      <router-link class="button button--inverse" to="login">Login</router-link>
      <router-link class="button button--outline" to="create">Sign up</router-link>
    </div>
    
    <router-link class="button button--link button--link-inverse" to="/wizard">Continue without an account</router-link>
  </layout-fullscreen>
</template>

<style scoped lang="scss">
  .heading {
    max-width: 350px;

    @include min-sm {
      max-width: 450px;
    }
  }
</style>

<script>
  import LayoutFullscreen from '@/layouts/Fullscreen';
  import RemaxLogo from '@/components/RemaxLogo';

  export default {
    name: 'AccountIntro',

    components: {
      LayoutFullscreen,
      RemaxLogo
    }
  };
</script>